// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6dc899c","eachWay":"_6a6078e","oddsboostTitle":"_c47753b","oddsboostTitleText":"_f5418a3"};